import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import InitiationWorkflow from './initiation-workflow';
import AuditWorkflow from './audit-workflow';
import Breadcrumbs from '../components/breadcrumbs-component';
import primeHelper from '../utils/prime-helper';

@inject('appStore')
@observer
export default class Workflow extends Component {
    constructor(props) {
        super(props);
    }

    handleOpenInSkySlopeButtonClick(e) {
        e.preventDefault();
        e.stopPropagation();

        primeHelper.logIntoPropertyFile(this.props.appStore.tcFileStore.selectedFile, appStore.viewStore.selectedTab);
    }

    render() {
        const propertyAddress = this.props.appStore.tcFileStore.selectedFile.propertyAddress,
            breadcrumbItems = [{ label: 'Files', href: '#/files' }, { label: propertyAddress }],
            isCalendarTimelineComplete = !!this.props.appStore.workflowStore.calendarTimelineStepState;

        return (
            <div className="workflow">
                <div className="row">
                    <div className="col-xs-12 col-md-9">
                        <Breadcrumbs items={breadcrumbItems} />
                    </div>
                    <div className="col-xs-12 col-md-3">
                        <button
                            className="btn btn-default pull-right"
                            onClick={this.handleOpenInSkySlopeButtonClick.bind(this)}
                        >
                            Open in SkySlope
                        </button>
                    </div>
                </div>

                <InitiationWorkflow />

                {isCalendarTimelineComplete ? <AuditWorkflow /> : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/workflow.js